import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59b7b6c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "nav",
  id: "nav"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#nav",
  class: "hamburger"
}, "☰", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://wiki.themanaworld.org/wiki/Downloads" }, "Download")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://wiki.themanaworld.org/wiki/FAQ" }, "FAQ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://wiki.themanaworld.org/" }, "Wiki")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://forums.themanaworld.org/" }, "Forums")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://policies.themanaworld.org/" }, "Policies & Rules")
], -1))
const _hoisted_8 = { class: "server" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Server Status", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "screenshots" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://wiki.themanaworld.org/wiki/Screenshots",
    title: "Screenshots",
    "aria-label": "view screenshots"
  }, "Screenshots")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Source Code"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://git.themanaworld.org/explore/groups",
        "aria-label": "source code for The Mana World"
      }, "The Mana World")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/mapeditor/tiled",
        "aria-label": "source code for Tiled"
      }, "Tiled")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ServerStatus = _resolveComponent("ServerStatus")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            class: _normalizeClass({ 'custom-active': _ctx.isHome }),
            to: { name: 'home' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'registration' } }, {
            default: _withCtx(() => [
              _createTextVNode("Create Account")
            ]),
            _: 1
          })
        ]),
        _hoisted_3,
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'about' } }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            class: _normalizeClass({ 'custom-active': _ctx.isSupport }),
            to: { name: 'support' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Support")
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_ServerStatus, { class: "status" })
    ]),
    _hoisted_10,
    _hoisted_11
  ]))
}